export const humanize = (str) =>
  str.split('_').map(s => `${s.charAt(0).toUpperCase()}${s.slice(1)}`).join(' ');
